import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/Navbar.css";
import logo from "../img/teragoldimage.png"

const productCategories = [
  {
    title: "Readers Sensors",
    path: "/readers-sensors",
    links: [
      { name: " ➤  UHF Card Reader", path: "/uhf-card-reader" },
      { name: " ➤  RFID - EM / Proximity / 125 KHz", path: "/rfid-em" }
    ],
  },
  {
    title: "Door Controller",
    path: "/door-controller",
    links: [
      { name: " ➤  Single Door Controller", path: "/single-door-controller" },
      { name: " ➤  Two Door Controller", path: "/two-door-controller" },
      { name: " ➤  Four Door Controller", path: "/four-door-controller" }
    ],
  },
  {
    title: "Barriers",
    path: "/barriers",
    links: [
      { name: " ➤  Boom Barriers", path: "/boom-barriers" },
      { name: " ➤  Flap Barriers", path: "/flap-barriers" }
    ],
  },
  {
    title: "Gates",
    path: "/gates",
    links: [
      { name: " ➤  Swing Gates", path: "/swing-gate" },
      { name: " ➤  Speed Gates", path: "/speed-gate" }
    ],
  },
  {
    title: "Guard Patrol Systems",
    path: "/guard-patrol-systems",
    links: []
  },
  {
    title: "Controllers",
    path: "/controller",
    links: [
      { name: " ➤  QR + RFID Access Controller", path: "/qr-rfid-access-controller" }
    ],
  },
  {
    title: "Biometrics",
    path: "/biometrics",
    links: [
      { name: " ➤  Face Recognition", path: "/face-recognition" },
      { name: " ➤  Finger Bio-Metrics", path: "/finger-bio-metrics" }
    ],
  },
];

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [activeLink, setActiveLink] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
    setPrevScrollPos(currentScrollPos);
    const navbar = document.querySelector(".tg-navbar");
    if (currentScrollPos > 10) {
      navbar.classList.add("tg-scrolled");
    } else {
      navbar.classList.remove("tg-scrolled");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  const toggleMenu = (event) => {
    event.stopPropagation();
    setShowMenu(!showMenu);
  };

  const closeMenu = () => {
    setShowMenu(false);
    setDropdownOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const handleLinkClick = (linkName) => {
    setActiveLink(linkName);
    scrollToTop();
    closeMenu();
  };

  return (
    <nav className={visible ? "tg-navbar tg-show fixed-top" : "tg-navbar fixed-top"} onClick={closeMenu}>
      <div className="tg-container">
        {/* Logo - Left */}
        <div className="tg-logo1">
          <img src={logo} alt="Logo" style={{ width: "100px", height: "100px" }} />
        </div>

        {/* Mobile Menu Icon */}
        <div className="tg-menu-icon" onClick={toggleMenu}>
          &#9776;
        </div>

        {/* Navigation Links - RIGHT side */}
        <div className={showMenu ? "tg-nav-links tg-show" : "tg-nav-links"}>
          <Link 
            to="/" 
            onClick={() => handleLinkClick("Home")} 
            className={activeLink === "Home" ? "tg-active" : ""}
          >
            Home <span></span>
          </Link>
          <Link 
            to="/aboutus" 
            onClick={() => handleLinkClick("About")} 
            className={activeLink === "About" ? "tg-active" : ""}
          >
            About <span></span>
          </Link>
          <Link 
            to="/imageslider" 
            onClick={() => handleLinkClick("Services")} 
            className={activeLink === "Services" ? "tg-active" : ""}
          >
            Services <span></span>
          </Link>
          <Link 
            to="/demo" 
            onClick={() => handleLinkClick("Products")} 
            className={activeLink === "Products" ? "tg-active" : ""}
          >
            Products <span></span>
          </Link>
          <Link 
            to="/contact" 
            onClick={() => handleLinkClick("Contact")} 
            className={activeLink === "Contact" ? "tg-active" : ""}
          >
            Contact Us <span></span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;